import React from "react";
import { Breadcrumb } from "../../../atoms/breadcrumb";
import { useTableHooks } from "../../../atoms/table/useTableHooks";
import { pascalToSnakeCase } from "../../../../utils";
import { Table } from "../../../atoms/table";
import { Input } from "../../../atoms/input";
import {
    NOTE_FOR_LICENSE_MANAGEMENT,
    PAGE_NAME,
} from "../../../../constants/constants";
import { useSaasToolWiseCostListQuery } from "../../../../store/cost/costSlice";

const formatColumnName = (name: string) => {
    switch (name) {
        case "totalLicense":
            return "total_licenses";
        case "saasTotalPrice":
            return "total";
        case "createAt":
            return "created_at";
        case "month":
            return "session";
        default:
            return name;
    }
};
const PricingList = () => {
    const pageClassName = "p-pricingList";

    const tableHeader = [
        {
            title: "Serial",
            dataIndex: "id",
            isSortable: true,
        },
        {
            title: "Saas Name",
            dataIndex: "toolName",
            isSortable: true,
        },
        {
            title: "Subscriptions Type",
            dataIndex: "subscriptionType",
            isSortable: true,
        },
        {
            title: "Month",
            dataIndex: "month",
            isSortable: true,
        },
        {
            title: "Renewal Date",
            dataIndex: "renewalDate",
            isSortable: true,
        },
        {
            title: "Total Licenses",
            dataIndex: "totalLicense",
            isSortable: true,
        },
        {
            title: "Unit Price",
            dataIndex: "unitPrice",
            isSortable: true,
        },
        {
            title: "Total Price",
            dataIndex: "saasTotalPrice",
            isSortable: true,
        },
        {
            title: "Created At",
            dataIndex: "createdAt",
            isSortable: true,
        },
    ];

    const { search, query, sortHandler, searchHandler } = useTableHooks();

    const { data, isLoading, isFetching } = useSaasToolWiseCostListQuery({
        search: query.search,
        limit: query.limit,
        current_page: query.current,
        sort_by: pascalToSnakeCase(formatColumnName(query.sortBy)),
        sort_direction: query.sortDirection,
    });


    return (
        <div className={pageClassName}>
            <Breadcrumb />

            {/* <div className={`${pageClassName}__card`}>
                <div className={`${pageClassName}__card__item`}>
                    <div className={`${pageClassName}__card__container`}>
                        <p className={`${pageClassName}__card__title`}>
                            Total Monthly Cost
                        </p>
                        <p className={`${pageClassName}__card__value`}>
                            {isSuccess
                                ? numberFormat(
                                    0
                                )
                                : 0}
                        </p>
                    </div>
                    <Icon icon="money" size="tertiary" />
                </div>
                <div className={`${pageClassName}__card__item`}>
                    <div className={`${pageClassName}__card__container`}>
                        <p className={`${pageClassName}__card__title`}>Total Yearly Cost</p>
                        <p className={`${pageClassName}__card__value`}>
                            {isSuccess
                                ? numberFormat(
                                    0
                                )
                                : 0}
                        </p>
                    </div>
                    <Icon icon="moneyBundle" size="tertiary" />
                </div>
                <div className={`${pageClassName}__card__item`}>
                    <div className={`${pageClassName}__card__container`}>
                        <p className={`${pageClassName}__card__title`}>
                            Number of Saas Tools
                        </p>
                        <p className={`${pageClassName}__card__value`}>
                            {isSuccess ? data?.result?.total : 0}
                        </p>
                    </div>
                    <Icon icon="saas" size="tertiary" />
                </div>
                <div className={`${pageClassName}__card__item`}>
                    <div className={`${pageClassName}__card__container`}>
                        <p className={`${pageClassName}__card__title`}>
                            Number of Licenses
                        </p>
                        <p className={`${pageClassName}__card__value`}>
                            {isSuccess
                                ? 0
                                : 0}
                        </p>
                    </div>
                    <Icon icon="license" size="tertiary" />
                </div>
            </div> */}
            <p className={`${pageClassName}__title`}>{PAGE_NAME.SAAS_TOOl_WISE_BUDGET}</p>
            <div className={`${pageClassName}__container`}>
                <div className={`${pageClassName}__header`}>
                    <div className={`${pageClassName}__search`}>
                        <Input
                            placeholder="Search"
                            onChange={searchHandler}
                            value={search}
                        />
                    </div>
                </div>
                <div className={`${pageClassName}__table`}>
                    <Table
                        header={tableHeader}
                        data={data?.result?.data ?? []}
                        loading={isLoading || isFetching}
                        firstLoad={isLoading}
                        sortHandler={sortHandler}
                        sortBy={query.sortBy}
                        minWidth="1440"
                        startIndex={data?.result?.from}
                    />
                    <p className={`${pageClassName}__note`}>
                        <span>*</span>
                        {NOTE_FOR_LICENSE_MANAGEMENT}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PricingList;
